import React, { useState } from 'react'
import { GxButton, GxIcon } from '@garpix/garpix-web-components-react'
import cn from 'classnames'
import DatePicker from 'react-multi-date-picker'
import dayjs from 'dayjs'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import { useStoreon } from 'storeon/react'
import Select from 'react-select'
import { Events, State } from '@/interfaces'
import PencilIcon from '../../../../assets/icons/PencilIcon.svg'
import PlusIcon from '../../../../assets/icons/PlusIcon.svg'
import CalendarIcon from '../../../../assets/icons/CalendarIcon.svg'
import { weekDays, months } from '../../../../const/calendar'
import SelectUser from '../../../../components/SelectUsers/Select'
import styles from './styles/index.module.scss'
import ModalOrder from '../ModalOrder'
import { customStatusSelect, statusOptions, TYPES_STATUS } from '../../consts'
import './styles/styles.css'
import useModal from '../../../../hooks/useModal'
import { MODALS_NAMES } from '../../../../const/modals'
import useModalFlag from '../../../../hooks/useModalFlag'
import { UserIcon } from '../../../../assets'
import Switcher from '../../../../components/Switcher'
import { TYPE_USER } from '../../../../const'

const SchedulePanel = () => {
  const [date, setDate] = useState<Date>(new Date())
  const {
    dispatch,
    statusTransferOrder,
    statusCreateMultiOrders,
    arrayDateTimeOrders,
    selectedUser,
    currentUser,
    ordersInfo
  } = useStoreon<State, Events>(
    'statusTransferOrder',
    'currentUser',
    'selectedUser',
    'statusCreateMultiOrders',
    'arrayDateTimeOrders',
    'ordersInfo'
  )
  const { openModal } = useModal()
  const { flag, setModalFlag } = useModalFlag()

  const openModalUser = (): void => {
    openModal(MODALS_NAMES.modalUser, { isEdit: false })
  }

  const openModalUserEdit = (): void => {
    openModal(MODALS_NAMES.modalUser, {
      isEdit: true,
      userId: selectedUser?.id
    })
  }

  function CustomRangeInput({ openCalendar, value }: any) {
    const valueNew = `${dayjs(value).format('DD.MM.YYYY')} ${dayjs(date).format('dddd')}`
    const handleClickBtnControl = (type: string) => {
      let newDate: Date
      if (type === 'back') {
        if (ordersInfo.range === 'week') {
          newDate = dayjs(date).subtract(7, 'day').toDate()
        } else {
          newDate = dayjs(date).subtract(1, 'day').toDate()
        }
      } else if (ordersInfo.range === 'week') {
        newDate = dayjs(date).add(7, 'day').toDate()
      } else {
        newDate = dayjs(date).add(1, 'day').toDate()
      }
      dispatch('ordersInfo/set', { date: dayjs(newDate).format('YYYY.MM.DD') })
      dispatch('orders/get')
      setDate(newDate)
    }
    return (
      <div className={styles['calendar']}>
        <label htmlFor='date'>
          <input
            id='date'
            value={valueNew}
            readOnly
            className={styles['calendar--input']}
            onFocus={openCalendar}
          />
        </label>
        <div className={styles['btn-control']}>
          <button
            type='button'
            onClick={() => handleClickBtnControl('back')}
            className={styles['btn-control--back']}
          />
          <button
            type='button'
            onClick={() => handleClickBtnControl('forward')}
            className={styles['btn-control--forward']}
          />
        </div>
        <div
          className={cn(styles['button'], styles['button--calendar'])}
          role='button'
          tabIndex={0}
          onClick={openCalendar}
        >
          <GxIcon className={styles['button--icon_calendar']} src={CalendarIcon} />
        </div>
      </div>
    )
  }

  const changeCalendar = (date: any) => {
    dispatch('ordersInfo/set', { date: date.format('YYYY.MM.DD') })
    dispatch('orders/get')
    setDate(date)
  }
  const handleClickCreateOrders = () => {
    setModalFlag()
    dispatch('statusCreateMultiOrders/set', true)
  }

  const handleClickCloseInfo = () => {
    dispatch('flagOrArray/clear')
  }

  const closeModal = (data?: Record<string, any>) => {
    if (data && (!data.customer || data.source === '' || data.tariff_rate_multi === null)) {
      dispatch('flagOrArray/clear')
    }
    setModalFlag()
  }

  const handleClickActiveOrder = (e: Record<string, any>) => {
    dispatch('ordersInfo/set', {
      is_show_all_order_statuses: e.target.checked
    })
    dispatch('orders/get')
  }

  return (
    <>
      <div className={styles['panel']}>
        <div className={styles['panel__left-group']}>
          <DatePicker
            weekDays={weekDays}
            months={months}
            value={date}
            weekStartDayIndex={1}
            onChange={(e) => changeCalendar(e)}
            render={<CustomRangeInput />}
          />
          <SelectUser className={styles['search']} />
          <GxButton
            disabled={!selectedUser?.id}
            className={cn(styles['button'], styles['button--view_people'])}
            onClick={openModalUserEdit}
          >
            <GxIcon className={styles['button--icon_add']} src={UserIcon} />
            <span className={styles['button--add_people--title']}>Просмотреть</span>
          </GxButton>
          {currentUser.user_status !== TYPE_USER.VIEWER && (
            <GxButton
              className={cn(styles['button'], styles['button--add_people'])}
              onClick={openModalUser}
            >
              <GxIcon className={styles['button--icon_add']} src={PlusIcon} />
              <span className={styles['button--add_people--title']}>Новый клиент</span>
            </GxButton>
          )}
          <label
            htmlFor='select-task'
            className={cn(styles['select--group'], styles['select--group__status'])}
          >
            <span className={styles['select--title']}>Статус:</span>
            <Select
              options={statusOptions}
              defaultValue={statusOptions[6]}
              styles={customStatusSelect}
              onChange={(e: Record<string, any> | null) => {
                if (e?.value === TYPES_STATUS.PAY_ONLINE) {
                  dispatch('ordersInfo/set', { status: undefined })
                } else {
                  dispatch('ordersInfo/set', { status: e?.value })
                }
                dispatch('orders/get')
              }}
            />
          </label>
          <Switcher
            label={!ordersInfo.is_show_all_order_statuses ? 'Активные' : 'Все'}
            onGx-change={handleClickActiveOrder}
            checked={ordersInfo.is_show_all_order_statuses}
            className={styles['switcher']}
          />
        </div>
        {currentUser.user_status !== TYPE_USER.VIEWER && (
          <div className={styles['panel__right-group']}>
            <GxButton
              className={cn(styles['button'], styles['button--create_record'])}
              onClick={handleClickCreateOrders}
              disabled={statusCreateMultiOrders || statusTransferOrder}
            >
              <GxIcon className={styles['button--icon_create']} src={PencilIcon} />
              <span>Создать запись</span>
            </GxButton>
          </div>
        )}
      </div>
      {statusTransferOrder && (
        <div className={styles['panel__info']}>
          <h2 className={styles['panel__info--title']}>Выберите время сессии!</h2>
          <GxButton
            className={cn(styles['button'], styles['button--close'])}
            onClick={handleClickCloseInfo}
          >
            <span>Отмена</span>
          </GxButton>
        </div>
      )}
      <TransitionGroup>
        {statusCreateMultiOrders && (
          <CSSTransition classNames='info' timeout={{ enter: 500, exit: 600 }}>
            <>
              <div className={styles['panel__info']}>
                <h2 className={styles['panel__info--title']}>Выберите время сессии!</h2>
                <div className={styles['panel__group']}>
                  <GxButton
                    className={cn(styles['button'], styles['button--close'])}
                    onClick={handleClickCloseInfo}
                  >
                    <span>Отмена</span>
                  </GxButton>
                  <GxButton
                    className={cn(styles['button'], styles['button--save'])}
                    onClick={setModalFlag}
                  >
                    <span>Забронировать</span>
                  </GxButton>
                </div>
              </div>
              <div className={styles['filters-date']}>
                <span>Выбрано:</span>
                <ul className={styles['filters-date--info__list']}>
                  {arrayDateTimeOrders.map((item) => (
                    <li
                      className={styles['filters-date--info__item']}
                      key={`${item.date} ${item.time}`}
                    >
                      <span>{`${dayjs(item.date, 'YYYY.MM.DD').format('DD.MM.YYYY')} ${
                        item.time
                      }`}</span>
                      <span
                        className={styles['filters-date--info__item_close']}
                        onClick={() =>
                          dispatch('arrayDateTimeOrders/delete', {
                            time: item.time,
                            date: item.date
                          })
                        }
                        role='button'
                        tabIndex={0}
                      />
                    </li>
                  ))}
                </ul>
              </div>
            </>
          </CSSTransition>
        )}
      </TransitionGroup>
      {flag && <ModalOrder flag={flag} closeModal={closeModal} />}
    </>
  )
}

export default SchedulePanel
